"use client";

import { useState, useEffect, useMemo, useCallback, memo } from 'react';
import dayjs from "dayjs";

import aboutMeContent from '../content/about-me.jsx';
import experienceContent from '../content/experience.jsx';
import SkillsContent from '../content/skills.jsx';
import ProjectsContent from '../content/projects.jsx';
import contactMeContent from '../content/contact-me.jsx';

import Modal from '../components/modal.jsx';
import NavButton from '../components/nav-button.jsx';

import cursorImg from '../../public/pngs/cursor.png';

function Main() {

  /**
   * Age / DayJS
   */
  const [myAge, setAge] = useState("");
  setTimeout(() => {
    setAge((dayjs().diff(dayjs(974246400000), "year", true)).toString().substring(0, 12));
  }, 100);

  /**
   * Mode
   */
  const [mode, setMode] = useState("about-me");
  const [modeContentClass, setModeContentClass] = useState("am-movein");
  useEffect(() => {
    setMode("about-me");
  }, []);

  const directionNone = "*NONE";
  const directionLeft = "*LEFT";
  const directionRight = "*RIGHT";

  const updateMode = useCallback((oldMode, newMode) => {

    /**
     * Calculate which direction the current content and new
     * content are moving to.
     */
    var direction = getDirection(oldMode, newMode);
    var outClass = "";
    var inClass = "";
    if ( window.screen.width <= 768 ) {
      outClass = "am-moveout-down";
      inClass = "am-movein-up";
    } else {
      outClass = ( direction === directionLeft ) ? "am-moveout-left" : "am-moveout-right";
      inClass = ( direction === directionLeft ) ? "am-movein-left" : "am-movein-right"
    }

    /**
     * Start moving in the selected direction, a set the timer
     * for the next content's intro transition.
     * If it's the same button, stay still!
     */
    if ( direction !== directionNone ) {
      setModeContentClass(outClass);
      const timer = setTimeout(() => {
        setMode(newMode);
        setModeContentClass(inClass);
        if ( window.screen.width <= 768 ) {
          setTimeout(() => document.getElementById('modeContent').scrollIntoView({ behavior: 'smooth' }), 500);
        }
      }, 375);
      return () => clearTimeout(timer);
    }
  }, []);

  function getDirection(oldMode, newMode) {
    var oldValue = getDirectionValue(oldMode);
    var newValue = getDirectionValue(newMode);

    if ( oldValue === newValue ) {
      return directionNone;
    } else {
      return ( oldValue > newValue ) ? directionRight : directionLeft;
    }
  }

  function getDirectionValue(mode) {
    switch( mode ) {
      case "about-me":
        return 0;
      case "experience":
        return 1;
      case "skills":
        return 2;
      case "projects":
        return 3;
      case "contact-me":
        return 4;
    }
  }

  /**
   * Modal
   */
  const [modalOptions, modalHandler] = useState({ "showModal": false, "mode": false });
  function modalHandlerWrapper( newOptions ) {
    modalHandler(newOptions);
    if ( window.screen.width <= 768 ) {
      window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    }
  }
  
  /**
   * Main Content
   */
  const content = useMemo(() => {
    switch(mode) {
      default:
      case "about-me":
        return aboutMeContent(myAge);
      case "experience":
        return experienceContent();
      case "skills":
        return <SkillsContent modalHandler={modalHandlerWrapper}/>;
      case "projects":
        return <ProjectsContent modalHandler={modalHandlerWrapper}/>;
      case "contact-me":
        return contactMeContent();
    }
  }, [mode, myAge, modalHandler]);

  return (
    <>
      <div className="flex justify-center w-full h-full min-h-screen bg-background" style={{ cursor: `url(${cursorImg.src}), auto` }}>
        <div className="w-full lg:w-3/5 mb-12 mx-8 lg:mx-0">
          <div className="my-12 lg:my-24 mr-auto">
            <h1 className="relative">Matt D Barnett</h1>
            <h2>Software Developer</h2>

            <div className="flex flex-col xl:flex-row mt-8 text-2xl text-white">
              <NavButton 
                highlight={ mode === "about-me" }
                onClick={ () => updateMode(mode, "about-me") }>
                  About Me
              </NavButton>
              <NavButton 
                highlight={ mode === "experience" }
                onClick={ () => updateMode(mode, "experience") }>
                  Experience
              </NavButton>
              <NavButton 
                highlight={ mode === "skills" }
                onClick={ () => updateMode(mode, "skills") }>
                  Skills
              </NavButton>
              <NavButton 
                highlight={ mode === "projects" }
                onClick={ () => updateMode(mode, "projects") }>
                  Projects
              </NavButton>
              <NavButton 
                highlight={ mode === "contact-me" }
                onClick={() => updateMode(mode, "contact-me")}>
                  Contact Me
              </NavButton>
            </div>
          </div>

          <div className=''>
            <div id="modeContent" className={modeContentClass}>
              {content}
            </div>
          </div>
        </div>
      </div>

      { Modal( modalOptions, modalHandler ) }
    </>
  );
}

export default Main;